import React from 'react'

export default function Container7() {
  return (
    <>
    <div className='cont7  py-5'>
    <div className='container my-5'>
        <h3 className='fw-bold'>Bereit für deine PiiBox?</h3>
        <h1 className='fw-bold'>Ergebnisse, die <span className='text-success1'>Erwartungen erfüllen</span></h1>
        
        <div className=' mx-auto text-center  pt-3 cont7d-flex  px-3 '>
            <div className='mx-3'>
            <img src='./cont7img.png' alt='not found' className='my-5 cont7_img img-fluid img-responsive'></img><br></br><span className='cont3para'>Mehr Buchungen</span>
            </div>
            <div className='mx-3'>
            <img  src='./cont7img2.png' alt='not found' className='my-5  cont7_img img-fluid  img-responsive'></img><br></br><span className='cont3para'>Mehr Telefonanrufe</span>
            </div>
            <div className='mx-3'>
            <img  src='./cont7img3.png' alt='not found' className='my-5  cont7_img img-fluid   img-responsive' ></img><br></br><span className='cont3para'>Mehr Ladenbesuche</span>
            </div>
       
        
        </div>
        </div>
        </div>
        
    
    </>
  )
}
